module.exports = __webpack_public_path__ + "img/y-202.fc3b800a.png";